import React, { useRef, useState } from "react";
import Editor from "components/shared/markdownEditor/MarkdownEditor";
import useInterceptorPrompt from "../../../hooks/useInterceptorPrompt";

interface ClosableTixxtComposerProps {
  onOpen: () => void;
  open: boolean;
  placeholder?: string;
  value: string;
  handleFullscreen: () => void;
}

export default function ClosableTixxtComposer({
  onOpen,
  open,
  ...props
}: ClosableTixxtComposerProps) {
  const editorRef = useRef<{ focus: () => void }>();
  const [closed, setClosed] = useState(!open);

  useInterceptorPrompt(
    I18n.t("js.composer.interceptor_prompt"),
    props.value.length > 0,
  );

  function onOpenHandler(e) {
    e.preventDefault();
    setClosed(false);
    onOpen();
    setTimeout(() => {
      editorRef.current?.focus();
    });
  }

  return closed ? (
    <button
      key="dummy"
      className={`ClosableTixxtComposer form-control closed text-left text-gray-400`}
      onClick={onOpenHandler}
    >
      <span className="placeholder">{props.placeholder}</span>
    </button>
  ) : (
    <div className="h-48">
      <Editor
        key={"real-deal"}
        {...props}
        editorRef={editorRef}
        enableTixxtMentions
      />
    </div>
  );
}
